import * as React from 'react'

// ---------------------------------------------------------------------------
// asChild → render shim
// ---------------------------------------------------------------------------
// Base UI replaces Radix's `asChild` boolean with a `render` prop that accepts
// a ReactElement (or render function). This helper extracts the single child
// when `asChild` is true and passes it as `render`, preserving our public API.
// ---------------------------------------------------------------------------

export function asChildProps(
  asChild: boolean | undefined,
  children: React.ReactNode,
): { render?: React.ReactElement; children?: React.ReactNode } {
  if (!asChild) return { children }
  const child = React.Children.only(children)
  if (!React.isValidElement(child)) return { children }
  return { render: child as React.ReactElement }
}
